module.exports = __webpack_public_path__ + "media/ordersuccess.164dc569.wav";